module.exports = __webpack_public_path__ + "img/img-auth-sideimg1.5248ded3.png";